import {Component, Input} from '@angular/core';
import {NgClassType} from "../../model/common.model";
import {MatButtonModule} from "@angular/material/button";
import {NgClass, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'preview-button',
  standalone: true,
  imports: [
    MatButtonModule,
    NgClass,
    RouterLink,
    NgIf,
    MatIconModule
  ],
  templateUrl: './preview-button.component.html'
})
export class PreviewButtonComponent {
  @Input() routerLink: any[] | string | null | undefined = ['preview']
  @Input() ngClass: NgClassType
  @Input() useLinkButton = true
}
